export const ERROR_CODES = {
  RECORD_NOT_FOUND: 'record_not_found',
};



// WEBPACK FOOTER //
// ./src/constants/error-codes.js